
import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { CardHeader, CardTitle } from '@/components/ui/card';

interface ProcurementApprovalHeaderProps {
  onBack: () => void;
  status: string;
  actions?: React.ReactNode;
}

export const ProcurementApprovalHeader: React.FC<ProcurementApprovalHeaderProps> = ({
  onBack,
  status,
  actions
}) => {
  return (
    <>
      <Button variant="ghost" onClick={onBack} className="mb-4">
        <ArrowLeft className="mr-2 h-4 w-4" /> Back to Finance Dashboard
      </Button>
      
      <CardHeader className="pb-2">
        <div className="flex justify-between items-start">
          <div>
            <CardTitle className="text-2xl">Procurement Review</CardTitle>
            <p className="text-muted-foreground mt-1">
              Review the procurement details and approve or reject
            </p>
          </div>
          <div className="flex items-center gap-2">
            {actions}
            <Badge variant={status === 'initiated' ? 'outline' : 'secondary'}>
              {status}
            </Badge>
          </div>
        </div>
      </CardHeader>
    </>
  );
};
